import { render, staticRenderFns } from "./Tercero.vue?vue&type=template&id=246ad378"
import script from "./Tercero.vue?vue&type=script&lang=js"
export * from "./Tercero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports